var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFwdButtonImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 76,
    viewBox: "0 0 68 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 2.13397L27.5 1.8453L27 2.13397L3.1843 15.884L2.6843 16.1726V16.75V44.25V44.8274L3.1843 45.116L27 58.866L27.5 59.1547L28 58.866L51.8157 45.116L52.3157 44.8274V44.25V16.75V16.1726L51.8157 15.884L28 2.13397Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "#E4DEFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39L28.7143 31.5L19 24V39ZM29.2857 24V39L39 31.5L29.2857 24Z",
    fill: "#E4DEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9810_3553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 39L28.7143 31.5L19 24V39ZM29.2857 24V39L39 31.5L29.2857 24Z",
    fill: "#E4DEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9810_3553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(19 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwdButtonImg);
export default __webpack_public_path__ + "static/media/FwdButtonImg.5b8b3a6be38c427c276bf3b5f2fccc99.svg";
export { ForwardRef as ReactComponent };